import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Skeleton Component
 * Based on shadcn/ui Skeleton with DckSlap dark red theme
 * For loading states
 */

function Skeleton({ className, ...props }) {
    return (
        <div
            className={cn(
                "animate-pulse rounded-md bg-muted",
                className
            )}
            {...props}
        />
    );
}

export { Skeleton };
